import { appConfig } from './app';

export const analyticsConfig = {
  domain: appConfig.appType,
  customer: 'Charter',
  appName: 'SelfInstallKit',
  appType: 'Web',
  appVersion: appConfig.version,
  deviceType: 'webBrowser',
  requirementsVersion: '2.5', // ensure requirementsVersion up-to-date by checking https://prism.spectrumtoolbox.com/SolutionMappingToolAdmin@Web/quantum-resources/helix
  msgTriggeredBy: 'user',
  startSession: '', // Disabled — EID 'SelfInstallKit_startSession_generic' is invalid per Helix AN-1001
  settings: {
    logLevel: 'error',
  },
};
